import React,{useEffect, useState} from 'react';
import {Button} from 'react-bootstrap';
import {Modal} from 'react-bootstrap';
//import "./ModalConfirmacion.css";

function ModalPersonalizado(datos) {
    const {comando,dispositivo,ids,cerrarModal,limpiarCheckbox} = datos;
    const [confirmado, setConfirmado]= useState(false);
    const [posicion, setPosicion] = useState();
    const [botonAceptar,setBotonAceptar] = useState("disable");

    const handleInputChange2 = (event) => {
        setPosicion(event.target.value);
    }

    const enviarComandoPerso = (event) => {
        event.preventDefault();
        fetch( window.location.protocol+"//"+window.location.hostname+"/api" + '/commands/sendCommandCustom', {
        method: 'POST',
        credentials: 'include',
        headers:{
            'idDevice': dispositivo,
            'idWithinDeviceTable': ids,
            'command': comando,
            'extraValue':posicion
        }
        })
        .then(response => { console.log(response)})
        .catch(e => { console.error(e);})
        
    }

    //Dependiendo de si se pode una posicion se habilita o deshabilita el botón de enviar
    useEffect(()=>{
        if(posicion != null && posicion!=undefined && posicion !=""){
            setBotonAceptar("") 
        }else{
            setBotonAceptar("disabled") 
        }
    },[posicion]);

    return (
        <div className="div">
            <form className="" onSubmit={enviarComandoPerso}>
                <div className="form-content">                    
                    <div className="mt-3">
                        <label>Grados a enviar:</label>
                        <input
                            type="number"
                            className="form-control mt-1"
                            placeholder="Introducir grados"
                            name="grados"
                            onChange={handleInputChange2}
                        />
                    </div>
                    <div className="d-grid gap-2 mt-3">
                        <button type="submit" className="btn btn-primary" disabled={botonAceptar} onClick={() => {setConfirmado(true);}}>Aceptar</button>
                    </div>
                    
                </div>
            </form>

            <Modal centered show={confirmado} onHide={() => (setConfirmado(false), cerrarModal(false))} backdrop="static" aria-labelledby="enviado" >
                <Modal.Header closeButton>
                    <Modal.Title>Confirmación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <a>Comando enviado, puede que tarde unos minutos en completarse.</a>
                    <br />
                    <Button type="button" className="button_confirm boton-aceptar-enviado" variant="success" size="sm" onClick={() => {setConfirmado(false);cerrarModal(false); limpiarCheckbox(true)}}>ACEPTAR</Button>
                </Modal.Body>
            </Modal>

        </div>
    )
}

export default ModalPersonalizado